import React from 'react'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import { Transformation } from 'cloudinary-react'

const CImage = (props) => {
  let CaptionTagName = props.captionTagName || 'figcaption'

  return (
    <>
      <DfbImage image={props.data.image[0]} aspect_ratio="16:9" add_class={props.add_class}>
        <Transformation crop="fill" gravity="faces:center" width="1024" height="576" quality="auto" fetchFormat="auto" />
      </DfbImage>
      {(props.data.image[0]?.description || props.data.image[0]?.copyright) && (
        <CaptionTagName className={props.captionClassName}>
          {props.data.image[0].description} {props.data.image[0].copyright}
        </CaptionTagName>
      )}
    </>
  )
}

export default CImage
